import { Card } from "./schemas";

const getCardTypeLabel = (
  cardType: "unknown" | "debit" | "credit" | "prepaid"
) => {
  switch (cardType) {
    case "debit":
      return "Debit";
    case "credit":
      return "Credit";
    case "prepaid":
      return "Prepaid";
    default:
      return "Credit";
  }
};

export const getCardDescription = (card: Card) =>
  `${getCardTypeLabel(card.card_type)} card ••• ${card.last_four}`;
